import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { getSuggestions, selectGeo, clearGeo, ISelectGeoParameters } from '../../actions/filters';
import { FilterGeo, IFilterGeoProps } from '../../components/FilterGeo';

type TFilterGeoStateProps = Pick<IFilterGeoProps, 'geoSuggestions' | 'jsonQuery'>;
type TFilterGeoDispatchProps = Pick<IFilterGeoProps, 'getSuggestions' | 'selectGeo' | 'clearGeo'>;

function mapStateToProps(state: IReduxState): TFilterGeoStateProps {
  return {
    jsonQuery: state.filters.jsonQuery,
    geoSuggestions: state.filters.geoSuggestions,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): TFilterGeoDispatchProps {
  return {
    getSuggestions: (query: string) => dispatch(getSuggestions({ query })),
    selectGeo: (geo: ISelectGeoParameters) => dispatch(selectGeo(geo)),
    clearGeo: () => dispatch(clearGeo()),
  };
}

export const FilterGeoContainer = connect(mapStateToProps, mapDispatchToProps)(FilterGeo);
